module.exports = __webpack_public_path__ + "img/1526960732.ab8f3271.jpg";